import Link from "next/link";
import { HEADER_V2_DESIGN_SYSTEM } from "./designTokens";
import { MenuNode } from "./menuAdapter";


interface MobileCategoryBarV2Props {
  categories: MenuNode[];
}

export default function MobileCategoryBarV2({ categories }: MobileCategoryBarV2Props) {
  const { colors } = HEADER_V2_DESIGN_SYSTEM;

  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <nav 
      aria-label="Mobile Categories Quick Bar"
      className={`md:hidden w-full ${colors.whiteBg} border-b border-slate-100 overflow-x-auto whitespace-nowrap py-2.5 px-4 flex gap-4 text-xs font-semibold text-slate-600 scrollbar-none`}
    >
      <Link href="/shop" className="hover:text-[var(--brand-accent)] transition-colors">
        All
      </Link>
      {categories.slice(0, 10).map((cat) => (
        <Link 
          key={cat.id} 
          href={cat.href} 
          className="hover:text-[var(--brand-accent)] capitalize transition-colors"
        >
          {cat.label}
        </Link>
      ))}
    </nav>
  );
}
